import type { AssessmentQuestion } from '@ts-assessment/interfaces'

import { AssessmentTopics } from '@ts-assessment/enums'

import imgQuestion5 from '@images/assessment/questions/ela/grade-k2/question-5.png'
import imgQuestion8 from '@images/assessment/questions/ela/grade-k2/question-8.png'
import imgQuestion10 from '@images/assessment/questions/ela/grade-k2/question-10.png'

export const questions: AssessmentQuestion[] = [
  {
    name: 'grade_k2_1',
    title: 'Which word rhymes with "light"?',
    topic: AssessmentTopics.ListeningAndSpeaking,
    answers: [
      {
        name: 'grade_k2_1_a',
        text: 'late',
      },
      {
        name: 'grade_k2_1_b',
        text: 'night',
        correct: true,
      },
      {
        name: 'grade_k2_1_c',
        text: 'let',
      },
    ],
  },
  {
    name: 'grade_k2_2',
    title: 'Which word begins with the same sound as "chair"?',
    topic: AssessmentTopics.ListeningAndSpeaking,
    answers: [
      {
        name: 'grade_k2_2_a',
        text: 'ship',
      },
      {
        name: 'grade_k2_2_b',
        text: 'cheese',
        correct: true,
      },
      {
        name: 'grade_k2_2_c',
        text: 'bear',
      },
    ],
  },
  {
    name: 'grade_k2_3',
    title: 'Which sentence would you say if you want to ask for something?',
    topic: AssessmentTopics.ListeningAndSpeaking,
    answers: [
      {
        name: 'grade_k2_3_a',
        text: 'I like your pencil.',
      },
      {
        name: 'grade_k2_3_b',
        text: 'I have a pencil.',
      },
      {
        name: 'grade_k2_3_c',
        text: 'May I use your pencil?',
        correct: true,
      },
    ],
  },
  {
    name: 'grade_k2_4',
    title: 'Read the sentence:',
    topic: AssessmentTopics.ReadingAndUnderstanding,
    detail: '“Liam put on his warm coat and boots before stepping outside into the snow.”',
    sentence: 'Why did Liam wear a coat and boots?',
    answers: [
      {
        name: 'grade_k2_4_a',
        text: 'He was going to bed.',
      },
      {
        name: 'grade_k2_4_b',
        text: 'It was cold and snowy.',
        correct: true,
      },
      {
        name: 'grade_k2_4_c',
        text: 'He wanted to go swimming.',
      },
    ],
  },
  {
    name: 'grade_k2_5',
    title: 'Read the sentence:',
    topic: AssessmentTopics.ReadingAndUnderstanding,
    detail: '“Sofia looked at the clock and realized she was almost late for school.”',
    sentence: 'What did Sofia realize?',
    image: imgQuestion5,
    answers: [
      {
        name: 'grade_k2_5_a',
        text: 'She forgot her homework.',
      },
      {
        name: 'grade_k2_5_b',
        text: 'She was already at school.',
      },
      {
        name: 'grade_k2_5_c',
        text: 'She will not be on time for school.',
        correct: true,
      },
    ],
  },
  {
    name: 'grade_k2_6',
    title: 'Read the sentence:',
    topic: AssessmentTopics.ReadingAndUnderstanding,
    detail: '“The hungry bunny hopped around the garden, looking for some fresh carrots to eat.”',
    sentence: 'What was the bunny looking for?',
    answers: [
      {
        name: 'grade_k2_6_a',
        text: 'Flowers',
      },
      {
        name: 'grade_k2_6_b',
        text: 'Vegetables',
        correct: true,
      },
      {
        name: 'grade_k2_6_c',
        text: 'Water',
      },
    ],
  },
  {
    name: 'grade_k2_7',
    title: 'Which sentence is written correctly?',
    topic: AssessmentTopics.Writing,
    answers: [
      {
        name: 'grade_k2_7_a',
        text: 'the dog barked at the cat.',
      },
      {
        name: 'grade_k2_7_b',
        text: 'The Dog Barked at the Cat',
      },
      {
        name: 'grade_k2_7_c',
        text: 'The dog barked at the cat.',
        correct: true,
      },
    ],
  },
  {
    name: 'grade_k2_8',
    title: 'Choose the best sentence to describe this picture: (imagine a picture of a girl flying a red kite in the park)',
    topic: AssessmentTopics.Writing,
    image: imgQuestion8,
    answers: [
      {
        name: 'grade_k2_8_a',
        text: 'The girl is flying.',
      },
      {
        name: 'grade_k2_8_b',
        text: 'The kite is red.',
      },
      {
        name: 'grade_k2_8_c',
        text: 'The girl is flying a red kite in the park.',
        correct: true,
      },
    ],
  },
  {
    name: 'grade_k2_9',
    title: 'Which word best completes this sentence?',
    topic: AssessmentTopics.Writing,
    detail: 'I like to ______ books before bed.',
    answers: [
      {
        name: 'grade_k2_9_a',
        text: 'jump',
      },
      {
        name: 'grade_k2_9_b',
        text: 'eat',
      },
      {
        name: 'grade_k2_9_c',
        text: 'read',
        correct: true,
      },
    ],
  },
  {
    name: 'grade_k2_10',
    title: 'Which word is an adjective in this sentence?',
    topic: AssessmentTopics.Language,
    detail: 'The tall giraffe ate leaves from the tree.',
    image: imgQuestion10,
    answers: [
      {
        name: 'grade_k2_10_a',
        text: 'giraffe',
      },
      {
        name: 'grade_k2_10_b',
        text: 'tall',
        correct: true,
      },
      {
        name: 'grade_k2_10_c',
        text: 'leaves',
      },
    ],
  },
  {
    name: 'grade_k2_11',
    title: 'Which word correctly completes the sentence?',
    topic: AssessmentTopics.Language,
    detail: 'She ______ to the store yesterday.',
    answers: [
      {
        name: 'grade_k2_11_a',
        text: 'go',
      },
      {
        name: 'grade_k2_11_b',
        text: 'going',
      },
      {
        name: 'grade_k2_11_c',
        text: 'went',
        correct: true,
      },
    ],
  },
  {
    name: 'grade_k2_12',
    title: 'Which word is a verb in this sentence?',
    topic: AssessmentTopics.Language,
    detail: 'The puppy chased the ball across the yard.',
    answers: [
      {
        name: 'grade_k2_12_a',
        text: 'puppy',
      },
      {
        name: 'grade_k2_12_b',
        text: 'chased',
        correct: true,
      },
      {
        name: 'grade_k2_12_c',
        text: 'ball',
      },
    ],
  },
]
